import { motion } from 'framer-motion';
import { NEONVERSE } from '../constants';

const NeonServices = () => (
  <section className="nv-section" id="services">
    <div className="nv-container">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.55 }}
      >
        <p className="nv-eyebrow">Services</p>
        <h2 className="nv-title">Custom Music for Every Occasion</h2>
        <p className="nv-lead">
          We create custom music for virtually any occasion. If you can imagine it, we can create
          music inspired by it.
        </p>
        <div className="nv-flow">
          {NEONVERSE.services.map((s) => (
            <span key={s}>{s}</span>
          ))}
          <span>And much more…</span>
        </div>
      </motion.div>
    </div>
  </section>
);

export default NeonServices;
